import { onLCP, onCLS, onINP, onTTFB } from "web-vitals";
import logger from "@/lib/logger";

type Metric = {
  name: string;
  value: number;
  rating: "good" | "needs-improvement" | "poor";
};

function sendToAnalytics(metric: Metric) {
  // Log to console for development
  logger.log("WEB_VITAL:", metric.name, metric.value, `(${metric.rating})`);

  // Send to Google Analytics if disponible
  if (typeof window.gtag !== "undefined") {
    window.gtag("event", metric.name, {
      custom_parameter_value: metric.value,
      custom_parameter_rating: metric.rating,
    });
  }

  // Send to Sentry como performance data si está disponible
  if (window.Sentry) {
    window.Sentry.addBreadcrumb({
      category: "performance",
      message: `${metric.name}: ${metric.value}`,
      level: "info",
      data: {
        value: metric.value,
        rating: metric.rating,
      },
    });
  }

  // Guardar para posible export o envío a API
  const vitals = (window as any).__webVitals || [];
  vitals.push({
    ...metric,
    timestamp: Date.now(),
    url: window.location.href,
  });
  (window as any).__webVitals = vitals;
}

// Inicializar tracking de Web Vitals
onLCP(sendToAnalytics);
onCLS(sendToAnalytics);
onINP(sendToAnalytics);
onTTFB(sendToAnalytics);

// Exportar para posible consumo por API
export const getWebVitals = () => (window as any).__webVitals || [];
